import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SpeedIcon from "@mui/icons-material/Speed";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHereSpeedLimit } from "../hooks/useHereSpeedLimit";
import { SpeedLimitReportDetails } from "../models/SpeedLimitReportData";

interface Props {
  details: SpeedLimitReportDetails;
}

export function HereSpeedLimitCell({ details }: Props) {
  const { t } = useTranslation();
  const [requested, setRequested] = useState(false);
  const result = useHereSpeedLimit(details.lat, details.lng, requested);

  switch (result.state) {
    case "no-key":
      return (
        <Tooltip title={t("speedLimitReport.hereLimitNoKey")}>
          <Box sx={{ color: "text.disabled" }}>—</Box>
        </Tooltip>
      );
    case "no-coords":
      return (
        <Tooltip title={t("speedLimitReport.hereLimitNoCoords")}>
          <Box sx={{ color: "text.disabled" }}>—</Box>
        </Tooltip>
      );
    case "idle":
      return (
        <Tooltip title={t("speedLimitReport.hereLimitLookUp")}>
          <Button
            size="small"
            variant="text"
            onClick={() => setRequested(true)}
            startIcon={<SpeedIcon fontSize="small" />}
            sx={{ textTransform: "none", minWidth: 0 }}
          >
            {t("speedLimitReport.hereLimitVerify")}
          </Button>
        </Tooltip>
      );
    case "loading":
      return <CircularProgress size={14} />;
    case "unrestricted":
      return (
        <Tooltip title={t("speedLimitReport.hereLimitUnrestricted")}>
          <Box sx={{ color: "text.primary" }}>
            {t("speedLimitReport.hereLimitUnrestrictedShort")}
          </Box>
        </Tooltip>
      );
    case "no-data":
      return (
        <Tooltip title={t("speedLimitReport.hereLimitNoData")}>
          <Box sx={{ color: "text.secondary", fontStyle: "italic" }}>
            {t("speedLimitReport.hereLimitNoDataShort")}
          </Box>
        </Tooltip>
      );
    case "error":
      return (
        <Tooltip title={`${t("speedLimitReport.hereLimitError")}: ${result.message}`}>
          <ErrorOutlineIcon fontSize="small" color="error" />
        </Tooltip>
      );
    case "ok": {
      const match = details.displayedLimit === result.kph;
      const label = `${result.kph} km/h`;
      return (
        <Box sx={{ fontWeight: match ? 400 : 600, color: match ? "text.primary" : "warning.main" }}>
          {label}
        </Box>
      );
    }
  }
}
